<template>
    <div class="wrapper">
      <div class="container details">
        <div class="row"><div class="col-md-10"><h1>Statistik snitt mil/leverans</h1></div></div>
        <div class="row">
          <div class="col-md-7">
            <div class="bg-white mt-4 p-4 border-solid">
              <h2>Registrera</h2>
              <div class="d-flex">
                <div class="mr-2">
                  <label>Välj period</label><br/>
                  <Calendar v-model="selectedPeriod" view="month" dateFormat="yy-mm" :showTime="false" :locale="sv" />
                </div>
                <div class="mr-2">
                  <label>Antal mil</label><br/>
                  <InputText type="text" name="km" v-model="distanceAmount" /><br/><br/>
                </div>
                <div>
                  <br/>
                  <Button v-if="selectedPeriod && distanceAmount" label="Registrera" @click="onSave()"></Button>
                </div>
              </div>
            </div>
            <div v-if="averageKm" class="bg-white mt-4 p-4 border-solid">
              <div v-if="totalAcidKm" class="mr-2">
                <h1>Snitt {{ selectedYear.name }}</h1>
                <div class="p-datatable p-component p-datatable-hoverable-rows mt-4">
                  <div class="p-datatable-wrapper">
                    <table role="grid">
                      <thead class="p-datatable-thead">
                        <tr>
                          <th style="text-align:left"><span class="p-column-title">Totalt antal körda mil</span></th>
                          <th style="text-align:left"><span class="p-column-title">Antal mil saltsyra</span></th>
                          <th style="text-align:left"><span class="p-column-title">Antal leveranser</span></th>
                          <th style="text-align:left"><span class="p-column-title">Genomsnitt mil/leverans (enkel resa)</span></th>
                        </tr>
                    </thead>
                    <tbody class="p-datatable-tbody">
                      <tr class="p-datatable-row">
                        <td>{{ setTotalDistance().toLocaleString('sv-SE') }} mil</td>
                        <td>{{ (totalAcidKm / 10).toLocaleString('sv-SE') }} mil</td>
                        <td>{{ totalDeliveries.toLocaleString('sv-SE') }} st</td>
                        <td>{{ averageKm }} mil</td>
                      </tr>
                    </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="bg-white mt-4 p-4 border-solid">
              <h2>Period</h2>
              <div class="d-flex">
                  <div class="mr-2">
                    <Dropdown v-model="selectedYear" @change="onSelectedYear" :options="years" optionLabel="name" placeholder="Välj år"/>
                  </div>
                  <div class="mr-2">
                    <Dropdown v-model="selectedSheetStartMonth" :options="sheetMonths" optionLabel="name" placeholder="Startmånad"/>
                  </div>
                  <div class="mr-2">
                    <Dropdown v-model="selectedSheetEndMonth" :options="sheetMonths" optionLabel="name" placeholder="Slutmånad"/>
                  </div>
                  <div class="mr-2">
                    <Button v-if="selectedYear" label="Generera rapport" @click="onGenerate()"></Button>
                  </div>
                </div>
              <div class="mt-4">
                <DataTable v-if="selectedYear && filteredDistances" :value="filteredDistances" :rowHover="true" :sortOrder="1" editMode="row" dataKey="id" :editingRows.sync="editingRows" @row-edit-init="onRowEditInit" @row-edit-cancel="onRowEditCancel" >
                  <Column field="date" header="Månad" bodyStyle="text-align:center" footerStyle="text-align:left">
                    <template #body="slotProps" >{{formatDate(slotProps.data.date)}}</template>
                  </Column>
                  <Column header="Distans" field="km" bodyStyle="text-align:center" footerStyle="text-align:right">
                    <template #body="slotProps" >
                      <InputText style="text-align:right" type="text" name="km" v-model="slotProps.data.km" />
                    </template>
                    <template #footer><strong>Totalt: {{ setTotalDistance().toLocaleString('sv-SE') }} mil</strong></template>
                  </Column>
                  <Column headerStyle="width:5rem" bodyStyle="text-align:center">
                    <template #body="slotProps" >
                      <Button class="p-button-success" title="Spara" @click="onSaveColumn(slotProps.data)" icon="pi pi-check" ></Button>
                    </template>
                  </Column>
                  <Column headerStyle="width:5rem" bodyStyle="text-align:center">
                    <template #body="slotProps" >
                      <Button class="p-button-danger" title="Ta bort" @click="onDelete(slotProps.data)" icon="pi pi-minus-circle" ></Button>
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toast position="bottomright" />
    </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Row from 'primevue/row'
import ColumnGroup from 'primevue/columngroup'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import moment from 'moment'
import Calendar from 'primevue/calendar'
import Dropdown from 'primevue/dropdown'
import ProgressSpinner from 'primevue/progressspinner'
import InputText from 'primevue/inputtext'
import Toast from 'primevue/toast'
export default {
  name: 'DistanceStats',
  components: {
    DataTable,
    Column,
    Dialog,
    Button,
    'Toast': Toast,
    moment,
    ColumnGroup,
    Calendar,
    InputText,
    Row,
    ProgressSpinner,
    Dropdown
  },
  data () {
    return {
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm',
        weekHeader: 'vk'
      },
      sv_year: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy',
        weekHeader: 'vk'
      },
      selectedPeriod: null,
      distanceAmount: null,
      selectedYear: null,
      selectedSheetStartMonth: null,
      selectedSheetEndMonth: null,
      sheetMonths: [],
      years: [],
      distances: [],
      filteredDistances: [],
      editingRows: [],
      totalAcidKm: null,
      totalDeliveries: null,
      averageKm: null,
      totalKm: null
    }
  },
  async mounted () {
    this.distances = await this.getAllDistances()
    this.getYears()
    let thisYear = moment().year()
    let exists = this.distances.filter((el) => moment(el.date).year() === thisYear)
    if (exists.length > 0) {
      this.selectedYear = {name: thisYear, value: thisYear}
      this.filteredDistances = this.distances.filter((x) => moment(x.date).year() === this.selectedYear.value)
      this.sheetMonths = this.getSheetMonths()
    }
  },
  computed: {
  },
  watch: {
    distances: function (newVal, oldVal) {
      this.distances = newVal
    },
    filteredDistances: function (newVal, oldVal) {
      this.filteredDistances = newVal
      this.sheetMonths = this.getSheetMonths()
    }
  },
  methods: {
    async getAllDistances () {
      let response = await this.$http.get('/api/distanceStats')
      return response.data
    },
    getYears () {
      this.distances.forEach((el) => {
        let year = moment(el.date).year()
        const checkExists = obj => obj.value === year

        if (!this.years.some(checkExists)) {
          this.years.push({name: year, value: year})
        }
      })
    },
    getSheetMonths () {
      let months = []
      for (let distance of this.filteredDistances) {
        let month = this.formatDate(distance.date)
        const checkExists = obj => obj.value === month

        if (!months.some(checkExists)) {
          months.push({name: month, value: month})
        }
      }
      months = months.sort((a, b) => a.value - b.value)
      return months
    },
    setTotalDistance () {
      let total = 0
      this.filteredDistances.forEach((el) => {
        if (el.km) {
          total += parseInt(el.km)
        }
      })
      return total
    },
    setTotalDistanceAcid () {
      let total = 0
      this.filteredDistances.forEach((el) => {
        if (el.acidKm) {
          total += parseInt(el.acidKm)
        }
      })
      return total
    },
    setTotalDeliveries () {
      let total = 0
      this.filteredDistances.forEach((el) => {
        if (el.deliveries) {
          total += parseInt(el.deliveries)
        }
      })
      return total
    },
    async updateDistances () {
      this.totalAcidKm = null
      this.distances = await this.getAllDistances()
      if (this.selectedYear) {
        this.filteredDistances = this.distances.filter((x) => moment(x.date).year() === this.selectedYear.value)
        this.$forceUpdate()
      }
    },
    onSelectedYear () {
      this.filteredDistances = this.distances.filter((x) => moment(x.date).year() === this.selectedYear.value)
    },
    formatDate (date) {
      return moment(date).format('MM')
    },
    onRowEditInit (event) {
      this.filteredDistances[event.index] = {...this.filteredDistances[event.index]}
    },
    onRowEditCancel (event) {
      this.filteredDistances[event.index] = this.filteredDistances[event.index]
    },
    async onGenerate () {
      const endMonth = parseInt(this.selectedSheetEndMonth.value.toString(), 10)
      const endLastDay = new Date(this.selectedYear.value, endMonth, 0).getDate()

      let startDate = this.selectedYear.value + '-' + this.selectedSheetStartMonth.value + '-' + '01'
      let endDate = this.selectedYear.value + '-' + this.selectedSheetEndMonth.value + '-' + endLastDay
      let response = await this.$http.get('/api/orders/by-daterange/between/' + startDate + '/' + endDate)
      let feralcoIntern = response.data.filter((x) => x.type === 'feralcoIntern')
      let inovynVetlandaNoRetur = feralcoIntern.filter((x) => x.data.loadingPlaces === 'Inovyn' && x.data.deliveryPlaces === 'Vetlanda' && x.data.retur === undefined && x.data.GroupLoading === undefined)
      let inovynVetlandaRetur = feralcoIntern.filter((x) => x.data.loadingPlaces === 'Inovyn' && x.data.deliveryPlaces === 'Vetlanda' && x.data.retur === true && x.data.GroupLoading === undefined)
      let inovynSolvesborgNoRetur = feralcoIntern.filter((x) => x.data.loadingPlaces === 'Inovyn' && x.data.deliveryPlaces === 'Sölvesborg' && x.data.retur === undefined && x.data.GroupLoading === undefined)
      let inovynSolvesborgRetur = feralcoIntern.filter((x) => x.data.loadingPlaces === 'Inovyn' && x.data.deliveryPlaces === 'Sölvesborg' && x.data.retur === true && x.data.GroupLoading === undefined)
      let kemiraVetlandaNoRetur = feralcoIntern.filter((x) => x.data.loadingPlaces === 'Kemira' && x.data.deliveryPlaces === 'Vetlanda' && x.data.retur === undefined && x.data.GroupLoading === undefined)
      let kemiraVetlandaRetur = feralcoIntern.filter((x) => x.data.loadingPlaces === 'Kemira' && x.data.deliveryPlaces === 'Vetlanda' && x.data.retur === true && x.data.GroupLoading === undefined)
      let kemiraSolvesborgNoRetur = feralcoIntern.filter((x) => x.data.loadingPlaces === 'Kemira' && x.data.deliveryPlaces === 'Sölvesborg' && x.data.retur === undefined && x.data.GroupLoading === undefined)
      let kemiraSolvesborgRetur = feralcoIntern.filter((x) => x.data.loadingPlaces === 'Kemira' && x.data.deliveryPlaces === 'Sölvesborg' && x.data.retur === true && x.data.GroupLoading === undefined)
      let totalKmInVetNoRetur = inovynVetlandaNoRetur.length * 550
      let totalKmInVetRetur = inovynVetlandaRetur.length * 275
      let totalKmInvSolNoRetur = inovynSolvesborgNoRetur.length * 678
      let totalKmInvSolRetur = inovynSolvesborgRetur.length * 339
      let totalKmKemVetNoRetur = kemiraVetlandaNoRetur.length * 504
      let totalKmKemVetRetur = kemiraVetlandaRetur.length * 252
      let totalKmKemSolNoRetur = kemiraSolvesborgNoRetur.length * 308
      let totalKmKemSolRetur = kemiraSolvesborgRetur.length * 154
      this.totalAcidKm = totalKmInVetNoRetur + totalKmInVetRetur + totalKmInvSolNoRetur + totalKmInvSolRetur + totalKmKemVetNoRetur + totalKmKemVetRetur + totalKmKemSolNoRetur + totalKmKemSolRetur

      let singleDeliveries = response.data.filter((x) => x.type === 'feralco' && x.data.GroupLoading === undefined)
      let groupDeliveries = response.data.filter((x) => x.type === 'feralco' && x.data.GroupLoading !== undefined)
      let groupLoadingArray = []
      groupDeliveries.forEach((el) => {
        let groupLoading = el.data.GroupLoading
        if (!groupLoadingArray.includes(groupLoading)) {
          groupLoadingArray.push(groupLoading)
        }
      })
      this.totalDeliveries = singleDeliveries.length + groupLoadingArray.length
      let average = (parseFloat(this.setTotalDistance()) - parseFloat(this.totalAcidKm / 10)) / this.totalDeliveries
      this.averageKm = parseFloat(average / 2).toFixed(2)
    },
    onSave () {
      var url = '/api/distanceStats'
      let date = this.selectedPeriod
      const exists = this.distances.filter((x) => moment(x.date).format('YY-MM') === moment(date).format('YY-MM'))
      if (exists !== undefined && exists.length > 1) {
        this.$toast.add({severity: 'error', summary: 'Perioden är redan registrerad', life: 3000})
      } else {
        this.$http
          .post(url, {
            distanceStats: {
              date: date,
              km: this.distanceAmount
            }
          })
          .then(async response => {
            this.selectedPeriod = null
            this.distanceAmount = null
            this.$toast.add({severity: 'success', summary: 'Sparad', life: 3000})
            await this.updateDistances()
          })
          .catch(error => console.log(error))
      }
    },
    onSaveColumn (data) {
      let message = 'Vill spara dina ändringar'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/distanceStats/' + data.id
          this.$http
            .put(url, {
              distanceStats: {
                km: data.km
              }
            })
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Sparad', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onDelete (data) {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/distanceStats/' + data.id
          this.$http
            .delete(url)
            .then(async response => {
              await this.updateDistances()
              this.$toast.add({severity: 'success', summary: 'Raderad', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Statistics/DistanceStats.vue